<h2 mat-dialog-title>{{ "selectModeDialog.title" | translate }}</h2>
<div class="grid-container">
  <!-- Distance -->
  <div class="card distance" [ngClass]="{ selectMode: isSelectMode('distance') }" (click)="changeMode('distance')">
    <div class="mode">
      <img src="assets/images/brian/btn_distance_nml.svg" />
      <div class="mode-label">{{ "selectModeDialog.distance" | translate }}</div>
    </div>
    <div class="description">
      <span class="detail-message">{{ "selectModeDialog.distanceDetail" | translate }}</span>
    </div>
  </div>

  <!-- Point to Line -->
  <div class="card point-to-line" [ngClass]="{ selectMode: isSelectMode('pointToLine') }" (click)="changeMode('pointToLine')">
    <div class="mode">
      <img src="assets/images/brian/btn_measure_point_nml.svg" />
      <div class="mode-label">{{ "selectModeDialog.pointToLine" | translate }}</div>
    </div>
    <div class="description">
      <span class="detail-message">{{ "selectModeDialog.pointToLineDetail" | translate }}</span>
    </div>
  </div>

  <!-- Depth -->
  <div class="card depth" [ngClass]="{ selectMode: isSelectMode('depth') }" (click)="changeMode('depth')">
    <div class="mode">
      <img src="assets/images/brian/btn_depth_nml.svg" />
      <div class="mode-label">{{ "selectModeDialog.depth" | translate }}</div>
    </div>
    <div class="description">
      <span class="detail-message">{{ "selectModeDialog.depthDetail" | translate }}</span>
    </div>
  </div>
</div>

<div class="grid-container">
  <!-- Lines -->
  <div class="card lines" [ngClass]="{ selectMode: isSelectMode('lines') }" (click)="changeMode('lines')">
    <div class="mode">
      <img src="assets/images/brian/btn_area_nml.svg" />
      <div class="mode-label">{{ "selectModeDialog.lines" | translate }}</div>
    </div>
    <div class="description">
      <span class="detail-message">{{ "selectModeDialog.linesDetail" | translate }}</span>
    </div>
  </div>

  <!-- Area -->
  <div class="card area" [ngClass]="{ selectMode: isSelectMode('area') }" (click)="changeMode('area')">
    <div class="mode">
      <img src="assets/images/brian/btn_area_nml.svg" />
      <div class="mode-label">{{ "selectModeDialog.area" | translate }}</div>
    </div>
    <div class="description">
      <span class="detail-message">{{ "selectModeDialog.areaDetail" | translate }}</span>
    </div>
  </div>
</div>

<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button [mat-dialog-close]="selectMode" color="primary">Close</button>
  </mat-dialog-actions>
</div>
